<script>
import { VEmojiPicker } from 'v-emoji-picker'
import { request } from '@/utils/request'
import TipModal from '@/components/tipModal/index.vue'
import emptys from '@/components/Emptys/index.vue'

export default {
  name: 'index',
  props: {
    // 接口路径
    allInterface: {
      type: Object,
      default: () => ({})
    },
    // 请求参数
    params: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    TipModal,
    VEmojiPicker,
    emptys
  },
  data() {
    return {
      total: 0,
      tabActive: 1,
      inpPh: '欢迎参与评论',
      btnShow: false,
      index: '0',
      replyComment: '',
      to: '',
      toId: -1,
      emoState: false,
      emoReplysState: false,
      comments: [],
      sortWay: 1,
      delVisible: false,
      deleteId: 0,
      moreList:[]
    }
  },
  methods: {
    getPopupContainer(trigger) {
      return trigger.parentElement
    },
    selectEmoji(emoji) {
      let input = document.getElementById('replyInput')
      input.innerHTML += emoji.data
      this.replyComment += emoji.data
    },
    selectReplyEmoji(emoji) {
      let input = document.getElementsByClassName('reply-comment-input')
      input[this.index].innerHTML += emoji.data
      this.replyComment += emoji.data
    },
    moreClick(i) {
      // this.$set(this.comments, i, false)
      console.log(this.comments[i].reply)
      this.comments[i].more = false
      this.comments[i].replys = this.comments[i].reply
      this.$set(this.comments)
    },
    tabClick(tab) {
      this.tabActive = tab
      this.sortWay = tab
      this.list()
    },
    showReplyBtn() {
      // this.btnShow = true
    },
    hideReplyBtn() {
      // this.btnShow = false
      var replyInput = document.getElementById('replyInput')
      replyInput.style.padding = '9px 21px 56px 21px'
      replyInput.style.border = '1px solid #D8DCE0'
    },
    showReplyInput(i, name, id) {
      let input = document.getElementsByClassName('reply-comment-input')
      for (let i = 0; i < input.length; i++) {
        if (i != this.index) {
          input[i].innerHTML = ''
        }
      }
      this.comments[this.index].inputShow = false
      this.index = i
      this.comments[i].inputShow = true
      this.toId = id
      console.log(this.toId)
      this.inpPh = this.$t('comment.action.reply') + name
    },
    _inputShow(i) {
      return this.comments[i].inputShow
    },
    isAllNbsp(input) {
      console.log(input)
      return /^(?:&nbsp;)+$/.test(input);
    },
    sendComment() {
      if (!this.replyComment) {
        this.$message.error(this.$t('comment.error.empty'))
      } else {
        let input = document.getElementById('replyInput')
        if(input.innerHTML!==''){
          let params = {
            resId: this.params.resId,
            resType: this.params.resType,
            parentId: 0,
            content: this.replyComment,
            res_url: window.location.href
          }
          this.send(params)
          input.innerHTML = ''
          this.replyComment=''
        }else{
          this.$message.error(this.$t('comment.error.empty'))
        }

      }
    },
    sendCommentReply(i, j) {
      console.log('发送',this.toId)
      if (!this.replyComment) {
        this.$message.error(this.$t('comment.error.empty'))
      } else {
        let input = document.getElementsByClassName('reply-comment-input')[i]
        if(input.innerHTML!==''&& input.innerHTML.trim().length !== 0){
          let params = {
            resId: this.params.resId,
            resType: this.params.resType,
            parentId: this.toId,
            content: this.replyComment,
            res_url: this.params.res_url
          }
          this.send(params)
          this.replyComment=''
          document.getElementsByClassName('reply-comment-input')[i].innerHTML = ''
        }else{
          this.$message.error(this.$t('comment.error.empty'))
        }
      }
    },
    onDivInput: function(e) {
      this.replyComment = e.target.innerText.replace(/^\s*/,'')
    },
    emoClick() {
      this.emoState = !this.emoState
    },
    emoReplyClick() {
      this.emoReplysState = !this.emoReplysState
    },
    hideIfOutside(event) {
      if (!event.target.closest('.emot')) {
        this.emoState = false
        this.emoReplysState = false
      }
    },
    send(params) {
      request({
        url: '/api' + this.allInterface.reply,
        method: 'post',
        data: params
      }).then(res => {
        if (res.code === 200) {
          this.list()
        }
      })
    },
    list() {
      request({
        url: '/api' + this.allInterface.list,
        method: 'get',
        params: { resId: this.params.resId, resType: this.params.resType, sortWay: this.sortWay }
      }).then(res => {
        if (res.code === 200) {
          let list = res.data.list
          this.total = Number(res.data.total)
          for (let i = 0; i < list.length; i++) {
            list[i].deleteState = false
            list[i].id = Number(list[i].id)
            list[i].comment =list[i].comment.replace(/&lt;br&gt;/g, '<br>')
            list[i].comment =list[i].comment.replace(/\n/g, '<br>')
            if (list[i].reply.length > 0) {
              for (let j = 0; j < list[i].reply.length; j++) {
                list[i].reply[j].deleteState = false
                list[i].reply[j].comment = list[i].reply[j].comment.replace(/&lt;br&gt;/g, '<br>')
                list[i].reply[j].comment = list[i].reply[j].comment.replace(/\n/g, '<br>')
              }
            }
              if(this.moreList.includes(list[i].id)){
                list[i].more = false
                list[i].replys = list[i].reply
              }else{
                if (list[i].reply.length > 2) {
                  list[i].replys = list[i].reply.slice(0, 2)
                  list[i].more = true
                  this.moreList.push( list[i].id)
                } else {
                  list[i].replys = list[i].reply
                  list[i].more = false
                  for(let s=0;s<this.moreList.length;s++){
                    if(this.moreList[s]==list[i].id){
                      this.moreList.splice(s,1)
                    }
                  }
                }
              }

          }
          this.moreList = [...new Set(this.moreList)]
          this.comments = list
        }
      })
    },
    deleteClick(id) {
      this.deleteId = id
      this.delVisible = true
    },
    del() {
      request({
        url: '/api' + this.allInterface.delete,
        method: 'post',
        data: { id: this.deleteId }
      }).then(res => {
        if (res.code === 200) {
          this.delVisible = false
          this.list()
          this.$message.success(this.$t('comment.success.delete'))
        }
      })
    },
    likcClick(isLike, id) {
      let that = this
      if (isLike) {
        request({
          url: '/api' + that.allInterface.unlike,
          method: 'post',
          data: { id }
        }).then(res => {
          if (res.code === 200) {
            that.delVisible = false
            that.list()
            that.$message.success(isLike ? this.$t('comment.success.unlike') : this.$t('comment.success.like'))
          }
        })
      } else {
        request({
          url: '/api' + that.allInterface.like,
          method: 'post',
          data: { id }
        }).then(res => {
          if (res.code === 200) {
            that.delVisible = false
            that.list()
            that.$message.success(isLike ? this.$t('comment.success.unlike') : this.$t('comment.success.like'))
          }
        })
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.hideIfOutside)
    this.list()
  },
  beforeDestroy() {
    document.addEventListener('click', this.hideIfOutside)
  }
}
</script>

<template>
  <div @click="hideIfOutside">
    <div class="my-reply">
      <div class="reply-info">
        <div
          tabindex="0"
          contenteditable="true"
          id="replyInput"
          spellcheck="false"
          :placeholder="$t('comment.placeholder')"
          class="reply-input"
          @focus="showReplyBtn"
          @output="hideReplyBtn"
          @input="onDivInput($event)"
        ></div>
        <div class="div_reply">
          <a-tooltip placement="bottom" overlayClassName="draw_atooltip" :overlayStyle="{ 'max-width': 'none' }">
            <template slot="title">
              <VEmojiPicker @select="selectEmoji" />
            </template>
            <img @click="emoClick" class="emo emot" src="@/assets/icons/icon_b@2x.png" alt="" />
          </a-tooltip>
          <div class="reply-btn-box">
            <a-button class="reply-btn" size="medium" @click="sendComment" type="primary">{{ $t('comment.publish') }}</a-button>
          </div>
        </div>
      </div>
      <!--      <div  v-if='emoState' @click.stop.prevent class='emo_select emot'>-->
      <!--        <VEmojiPicker @select="selectEmoji" />-->
      <!--      </div>-->
    </div>
    <div v-if="total > 0">
      <div class="reply-title">
        <div class="reply-title-left">{{ $t('comment.title', { count: total }) }}</div>
        <div class="reply-title-right">
          <div :class="{ 'reply-title-active': tabActive == 1 }" @click="tabClick(1)">{{ $t('comment.sort.default') }}</div>
          <div></div>
          <div :class="{ 'reply-title-active': tabActive == 2 }" @click="tabClick(2)">{{ $t('comment.sort.latest') }}</div>
        </div>
      </div>
      <div v-for="(item, i) in comments" :key="i" class="author-title reply-father">
        <div class="author-title-top" @mouseover="item.deleteState = true" @mouseleave="item.deleteState = false">
          <img
            class="header-img"
            :src="item.headImg == '' ? require('@/assets/icons/icon_touxiang@2x.png') : item.headImg"
            alt=""
          />
          <div class="author-info">
            <span class="author-name author-name-t">{{ item.name }}</span>
            <a-tooltip placement="bottom">
              <template slot="title">
                <span>{{ $t('comment.action.delete') }}</span>
              </template>
              <div class="delete" v-show="item.isSelf" :style="{ opacity: item.deleteState ? 1 : 0 }" @click="deleteClick(item.id)">
                <div></div>
                <div></div>
                <div></div>
              </div>
            </a-tooltip>
          </div>
        </div>
        <div class="talk-box-f" @mouseover="item.deleteState = true" @mouseleave="item.deleteState = false">
          <p>
            <div class="reply" v-html="item.comment"></div>
          </p>
          <div class="time">
            <div>
              <span class="author-time">{{ item.showTip }}</span>
            </div>
            <div class="icon-btn">
              <div @click="likcClick(item.isLike, item.id)" :class="{like: item.isLike}">
                <img v-if="item.isLike" src="@/assets/icons/icon_z_true.png" alt="" />
                <img v-else src="@/assets/icons/icon_z_false.png" alt="" />
                {{ item.like }}
              </div>
              <div @click="showReplyInput(i, item.name, item.id)">
                <img src="@/assets/icons/icon_pl@2x.png" alt="" />{{ $t('comment.action.reply') }}
              </div>
            </div>
          </div>
        </div>
        <div class="reply-box">
          <div
            v-for="(reply, index) in item.replys"
            :key="index"
            class="author-title"
            @mouseover="reply.deleteState = true"
            @mouseleave="reply.deleteState = false"
          >
            <div class="author-title-w">
              <div class="author-title-top">
                <img
                  class="header-img"
                  :src="reply.fromHeadImg == '' ? require('@/assets/icons/icon_touxiang@2x.png') : reply.fromHeadImg"
                  alt=""
                />
                <div class="author-info">
                  <span class="author-name">{{ reply.from }} <span class="reply">{{ $t('comment.action.reply') }}</span>{{ reply.to }}</span>
                  <a-tooltip placement="bottom">
                    <template slot="title">
                      <span>{{ $t('comment.action.delete') }}</span>
                    </template>
                    <div class="delete" v-show="reply.isSelf" :style="{ opacity: reply.deleteState ? 1 : 0 }" @click="deleteClick(reply.fromId)">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </a-tooltip>
                </div>
              </div>
              <div class="talk-box">
                <p>
                  <div class="reply" v-html="reply.comment"></div>
                </p>
                <div class="time">
                  <div>
                    <span class="author-time">{{ reply.showTip }}</span>
                  </div>
                  <div class="icon-btn">
                    <div @click="likcClick(reply.isLike, reply.fromId)">
                      <img v-if="reply.isLike" src="@/assets/icons/icon_z_true.png" alt="" />
                      <img v-else src="@/assets/icons/icon_z_false.png" alt="" />
                      {{ reply.like }}
                    </div>

                    <div @click="showReplyInput(i, reply.from, reply.fromId)">
                      <img src="@/assets/icons/icon_pl@2x.png" alt="" />{{ $t('comment.action.reply') }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="item.more && item.reply.length > 2 && index == 1" class="more" @click="moreClick(i)">
              {{ $t('comment.action.view') }}>
            </div>
          </div>
        </div>
        <div v-show="_inputShow(i)" class="my-reply my-comment-reply">
          <div class="reply-info">
            <div
              tabindex="0"
              contenteditable="true"
              spellcheck="false"
              :placeholder="inpPh"
              @input="onDivInput($event)"
              class="reply-input reply-comment-input"
            ></div>
            <div class="div_reply">
              <a-tooltip placement="bottom" overlayClassName="draw_atooltip" :overlayStyle="{ 'max-width': 'none' }">
                <template slot="title">
                  <VEmojiPicker @select="selectReplyEmoji" />
                </template>
                <img @click="emoReplyClick" class="emo emot" src="@/assets/icons/icon_b@2x.png" alt="" />
              </a-tooltip>
              <div class="reply-btn-box">
                <a-button class="reply-btn" size="medium" @click="sendCommentReply(i, j)" type="primary">{{ $t('comment.action.reply') }}</a-button>
              </div>
            </div>
          </div>
          <!--        <div  v-if='emoReplysState' @click.stop.prevent class='emo_select emot'>-->
          <!--          <VEmojiPicker @select="selectReplyEmoji" />-->
          <!--        </div>-->
        </div>
      </div>
    </div>
    <div class='null_state' v-else>
      <div>
        <img src="@/assets/img/bj_zanwu@2x.png" alt=''>
        <div class="no_creat_text">{{ $t('comment.empty') }}</div>
      </div>
    </div>
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="
        `<p>${$t('comment.dialog.delete.title')}</p>
        <p class='placeholder'>${$t('comment.dialog.delete.content')}</p>`"
    />
  </div>
</template>
<style lang="less">
.draw_atooltip {
  .ant-tooltip-inner {
    // 这里是框框
    background-color: #f0f0f0 !important;
  }
  .ant-tooltip-arrow::before {
    // 这里是小三角形
    background-color: #f0f0f0 !important;
  }
}
</style>
<style scoped lang="less">
/deep/.emoji-picker {
  //width: 35% !important;
  height: 210px;
}
/deep/ #InputSearch {
  display: none !important;
}
/deep/ #Categories {
  min-height: 35px !important;
}
/deep/ .container-emoji {
  height: 175px !important;
}

.my-reply {
  position: relative;
  .header-img {
    display: inline-block;
    vertical-align: top;
    width: 29px;
    height: 29px;
  }
  .emo_select {
    position: relative;
    left: 0;
    bottom: -252%;
    display: inline;
  }

  .reply-info {
    position: relative;
    display: inline-block;
    width: 100%;
    //margin-bottom: 22px;

    //@media screen and (max-width: 1200px) {
    //  width: 80%;
    //}
    .div_reply {
      display: flex;
      position: absolute;
      bottom: 0;
      left: 0px;
      width: 98%;
      justify-content: space-between;
      border-top: 1px solid #e5e7e9;
      transform: translate(1%, -2%);
      .emo {
        cursor: pointer;
        width: 22px;
        height: 22px;
        margin-top: 12px;
        margin-left: 16px;
      }
    }
    .reply-input {
      min-height: 141px;
      background: #fcfcfc;
      border: 1px solid #d8dce0;
      box-sizing: border-box;
      line-height: 22px;
      padding: 9px 21px 56px 21px;
      color: #000000;
      border-radius: 5px;

      &:empty:before {
        content: attr(placeholder);
        color: #a2a2a2;
      }

      &:focus:before {
        content: none;
      }

      &:focus {
        padding: 9px 21px 56px 21px;
        border: 1px solid #fea064;
        box-shadow: none;
        outline: none;
      }
    }
  }

  .reply-btn-box {
    margin: 7px 9px 7px 0;
    display: flex;
    justify-content: end;
    button {
      background: linear-gradient( 224deg, #FEA064 0%, #FF7F44 100%) !important;
      min-width: 75px;
    }
  }
}

.reply-title {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  margin-top: 22px;

  &-left {
    font-weight: 500;
    font-size: 16px;
    color: #000000;
  }

  &-right {
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    display: flex;
    margin-top: 12px;

    & > div:nth-child(2) {
      width: 1px;
      height: 9px;
      background: #d9d9d9;
      margin: 6px 9px 0 9px;
    }

    & > div:nth-child(1),
    & > div:nth-child(3) {
      cursor: pointer;
    }
  }

  .reply-title-active {
    color: #ff5500 !important;
    font-weight: 500;
  }
}

.my-comment-reply {
  margin-left: 40px;
  //margin-bottom: 23px;

  .reply-input {
    width: flex;
  }
}

.author-title:not(:last-child) {
  //border-bottom: 1px solid rgba(178, 186, 194, 0.3);
}

.reply-father {
  margin-top: 22px;
  border-bottom: 1px solid #ececec;
  padding-bottom: 24px;
}

.author-title-top {
  display: flex;
}

.time {
  display: flex;
  justify-content: space-between;
}

.author-time {
  display: inline-block;
  margin-top: 13px;
  font-weight: 400;
  font-size: 12px;
  color: #a1a1a1;
  //margin-bottom: 12px;
}

.author-title {
  .author-title-w {
    padding: 12px 0px 0 12px;
  }

  .header-img {
    display: inline-block;
    vertical-align: top;
    height: 29px;
    width: 29px;
    border-radius: 50%;
  }

  .author-info {
    display: inline-block;
    width: 100%;
    line-height: 20px;
    margin-left: 12px;
    display: flex;
    justify-content: space-between;
    .delete {
      width: 18px;
      height: 18px;
      border-radius: 50%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      cursor: pointer;
      margin-right: 14px;
      > div {
        width: 2px;
        height: 2px;
        border-radius: 50%;
        background: #5a6b83;
        margin: 1px auto;
      }
    }
    .delete:hover {
      background: #e6e6e6;
    }
    .reply {
      display: inline-block;
      margin: 0 6px;
      font-weight: 500;
      font-size: 14px;
      color: #a2a2a2;
    }

    > span {
      display: block;
      cursor: pointer;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    .author-name {
      font-weight: 600;
      font-size: 14px;
      color: #595959;
    }
    .author-name-t{
      color: #000000 !important;
    }
  }
  .my-comment-reply {
    //margin-top: -12px;
  }

  .icon-btn {
    display: flex;
    margin-top: 15px;
    .like{
      color: #EF623D !important;
    }
    > div {
      cursor: pointer;
      display: flex;
      font-size: 12px;
    }
    > div:nth-child(1) {
      img {
        width: 17px;
        height: 16px;
        margin-right: 4px;
      }
    }
    > div:nth-child(2) {
      margin-left: 26px;
      margin-right: 14px;
      img {
        width: 14px;
        height: 15px;
        margin-right: 5px;
        margin-top: 3px;
      }
    }
  }
  .talk-box-f {
    margin-left: 40px;
    > p {
      margin: 0;
    }

    .reply {
      font-size: 16px;
      color: #000;
    }
  }
  .talk-box {
    margin-left: 40px;
    border-bottom: 1px solid #ececec;
    padding-bottom: 8px;

    > p {
      margin: 0;
    }

    .reply {
      font-size: 16px;
      color: #000;
    }
  }

  .reply-box {
    margin: 10px 0 0px 40px;
    background-color: #f7f8f9;

    .more {
      font-weight: 600;
      font-size: 12px;
      color: #4495d1;
      cursor: pointer;
      padding-bottom: 8px;
      padding-left: 12px;
    }
  }

  .reply-box .author-title:last-child {
    .talk-box {
      border-bottom: none;
    }
  }
}
/deep/.ant-modal-mask {
  background: rgba(0, 0, 0, 0.6);
}
.null_state{
  text-align: center;
  margin:100px auto 0 auto;
  >div{
    img{
      width: 284px;
    }
    div{
      font-size: 14px;
      margin-top: -48px;
      font-weight: 600;
    }
  }
}
</style>
